import { extendTheme, theme, themeTools } from "native-base"
import { color } from "./color"

export * from "./color"
export * from "./spacing"
export * from "./typography"
export * from "./timing"
export * from "./images"

export const nativeBaseTheme = extendTheme({
  colors: {
    primary: {
      200: color.palette.blue200,
      300: color.palette.blue300,
      400: color.palette.blue400,
      500: color.palette.blue500,
      600: color.palette.blue600,
      700: color.palette.blue700,
    },
    success: {
      300: color.palette.green300,
      400: color.palette.green400,
      500: color.palette.green500,
      600: color.palette.green600,
    },
    danger: {
      300: color.palette.red300,
      400: color.palette.red400,
      500: color.palette.red500,
      600: color.palette.red600,
      700: color.palette.red700,
    },
    error: {
      300: color.palette.red300,
      400: color.palette.red400,
      500: color.palette.red500,
      600: color.palette.red600,
      700: color.palette.red700,
    },
    muted: {
      100: color.palette.gray100,
      200: color.palette.gray200,
      500: color.palette.gray500,
      600: color.palette.gray600,
      700: color.palette.gray700,
      800: color.palette.gray800,
      900: color.palette.gray900,
    },
    gray: {
      100: color.palette.gray100,
      200: color.palette.gray200,
      300: color.palette.gray300,
      400: color.palette.gray400,
      500: color.palette.gray500,
      600: color.palette.gray600,
      700: color.palette.gray700,
      800: color.palette.gray800,
      900: color.palette.gray900,
    }
  },
  components: {
    Icon: {
      baseStyle: (props: Record<string, any>) => ({
        color: themeTools.mode("muted.700", "muted.300")(props)
      })
    },
    InputBase: {
      ...theme.components.Input
    },
    Input: {
      baseStyle: (props: Record<string, any>) => ({
        _disabled: {
          bg: "transparent"
        },
        _text: {
          color: "gray.500"
        }
      })
    }
  },
  config: {
    useSystemColorMode: false,
    initialColorMode: "light"
  }
});
